<template>
    <div class="kit-detail">
        <div v-if="noResult" class="kit-detail-inspectoscope">
            <h2>TDK检查器</h2>
            <el-alert
                    title="填写目标网页URL后,系统会自动抓取网页目录及页面title,keywords,description等信息,并将结果发送至接收邮箱"
                    type="info"
                    :closable="false"
                    class="inspectoscope-box"
            >
            </el-alert>
            <el-form label-width="80px" :model="formData" ref="formData" :rules="rules1">
                <el-form-item label="网页URL" prop='url'>
                    <el-input v-model="formData.url"></el-input>
                </el-form-item>
                <el-form-item label="接收邮箱" prop='emails'>
                    <el-input placeholder="请输入内容" v-model="formData.emails">
                        <template slot="append">@skytech.cn</template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('formData')">确认检查</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div v-else class="kit-detail-inspectoscope">
            <h2>成功建立检查任务</h2>
            <h5 class="text">目标网页内容正在抓取中，成功后会将结果发送至目标邮箱，请注意查收。</h5>
            <el-button type="primary" @click="noResult = true">再查一单</el-button>
        </div>
    </div>
</template>

<script>
    import ajax from '@/backend/services/website/website.js';

    export default {
        data() {
            var checkUrl = (rule, value, callback) => {
                const urlReg = /((ht|f)tps?:)\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
                if (!value) {
                    return callback(new Error('url不能为空'))
                }
                setTimeout(() => {
                    if (urlReg.test(value)) {
                        callback()
                    } else {
                        callback(new Error('请输入正确的url格式'))
                    }
                }, 100)
            }
            var checkEmail = (rule, value, callback) => {
                const mailReg = /[a-zA-Z0-9_-]/;
                if (!value) {
                    return callback(new Error('邮箱不能为空'))
                }
                setTimeout(() => {
                    if (mailReg.test(value)) {
                        callback()
                    } else {
                        callback(new Error('请输入正确的邮箱格式'))
                    }
                }, 100)
            }
            return {
                formData: {
                    url: '',
                    emails: ''
                },
                noResult: true,
                rules1: {
                    url: [
                        {validator: checkUrl, trigger: 'blur'},
                    ],
                    emails: [
                        {validator: checkEmail, trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            async getCreatewebtkd(val) {
                let datas = await ajax.getCreatewebtkd(val)
                if (datas.status == 200) {
                    this.$message('提交成功')
                    this.noResult = false
                    this.formData.url = ''
                    this.formData.emails = ''
                }

            },
            submitForm(formData) {
                var that = this
                this.$refs[formData].validate((valid) => {
                    if (valid) {
                        let emails = that.formData.emails + '@skytech.cn'
                        that.getCreatewebtkd({
                            url: that.formData.url,
                            emails: emails
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .text {
        margin: 40px 0;
    }
    .kit-detail {
        width: 100%;
        height: 100%;
        background: #ffffff;
        padding: 20px;
        text-align: center;
        .inspectoscope-box {
            margin: 50px 0;
        }
        .kit-detail-inspectoscope {
            width: 50%;
            margin: auto;
        }
        .el-form-item {
            margin-bottom: 50px;
        }
        .el-alert__title {
            font-size: 24px;
            line-height: 40px;
        }
        .el-alert .el-alert__description {
            font-size: 18px;
        }
    }
</style>
